import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { BLACK_500, BLACK_700, BLACK_900, RED_500, DISTANT, GREEN_600, TRANSPARENT, YELLOW_600, YELLOW_500, linkListItemConfig, tokens, BLACK_100 } from '../../constants';
import { checkIsPlatform, getCurrentEventControlState } from '../../utils';
export var getTypography = (type, isLargeScreen) => {
  var TYPOS = {
    small: {
      title: 'title-single-line-md',
      heading: 'body-para-sm-bold',
      subHeading: 'body-para-sm',
      subHeadingBold: 'body-para-sm-bold',
      subText: 'body-para-sm',
      subTextBold: 'body-para-sm-bold',
      subText3: 'body-para-sm',
      subText3Bold: 'body-para-sm-bold',
      metaInfoText: 'body-para-sm-bold'
    },
    large: {
      title: 'title-single-line-lg',
      heading: 'body-para-md-bold',
      subHeading: 'body-para-md',
      subHeadingBold: 'body-para-md-bold',
      subText: 'body-para-md',
      subTextBold: 'body-para-md-bold',
      subText3: 'body-para-md',
      subText3Bold: 'body-para-md-bold',
      metaInfoText: 'body-single-line-md-bold'
    }
  };
  return isLargeScreen ? TYPOS.large[type] : TYPOS.small[type];
};
export var getLinkListItemComponentSize = (componentType, isLargeScreen, actionType) => {
  var listItemSize = {
    avatarSize: isLargeScreen ? 'md' : 'sm',
    iconSize: isLargeScreen ? actionType == 'button-icon' ? 24 : 28 : 20,
    buttonSize: isLargeScreen ? 'md' : 'sm',
    radioSize: 'md',
    textSize: isLargeScreen ? 'body-single-line-xl' : 'body-single-line-lg',
    infoTagSize: isLargeScreen ? 'md' : 'sm',
    checkboxSize: 'sm',
    switchSize: 'sm'
  };
  return listItemSize === null || listItemSize === void 0 ? void 0 : listItemSize[componentType];
};
export var getTypographyColorWithDifferentStates = (props, typoType, pressableState) => {
  var _a;
  var controlState = props.controlState,
    config = props.config;
  var controlStates = config.controlStates;
  var eventState = getCurrentEventControlState(pressableState, controlState);
  return (props === null || props === void 0 ? void 0 : props[typoType]) || ((_a = controlStates === null || controlStates === void 0 ? void 0 : controlStates[eventState]) === null || _a === void 0 ? void 0 : _a[typoType]);
};
export var getLinkListItemStyles = (props, pressableState, isLargeScreen) => {
  var _a, _b, _c;
  var heading = props.heading,
    title = props.title,
    headingInfoTag = props.headingInfoTag,
    subHeading = props.subHeading,
    subHeadingBold = props.subHeadingBold,
    subText = props.subText,
    subTextBold = props.subTextBold,
    subText3 = props.subText3,
    subText3Bold = props.subText3Bold,
    metaInfoTag = props.metaInfoTag,
    metaInfoText = props.metaInfoText,
    metaInfoCta = props.metaInfoCta,
    controlState = props.controlState,
    config = props.config,
    _backgroundColor = props.backgroundColor,
    avatarPosition = props.avatarPosition,
    roundedCorners = props.roundedCorners,
    noHoverEffect = props.noHoverEffect,
    noPressEffect = props.noPressEffect,
    avatarNoBgContainer = props.avatarNoBgContainer,
    noPadding = props.noPadding,
    showShadow = props.showShadow,
    noVerticalPadding = props.noVerticalPadding,
    noHorizontalPadding = props.noHorizontalPadding,
    actionTypePosition = props.actionTypePosition,
    avatarAsOffer = props.avatarAsOffer,
    imagePosition = props.imagePosition,
    isIllustration = props.isIllustration,
    disableAppendActionType = props.disableAppendActionType;
  var spacingToken = tokens.spacing;
  var borderToken = tokens.borderRadius;
  var controlStates = config.controlStates;
  var headingLottieSize = config.headingLottieSize;
  var eventState = getCurrentEventControlState(pressableState, controlState);
  var backgroundColor = _backgroundColor || ((_a = controlStates === null || controlStates === void 0 ? void 0 : controlStates[eventState]) === null || _a === void 0 ? void 0 : _a.backgroundColor);
  var avatarBackgroundColor = (_b = controlStates === null || controlStates === void 0 ? void 0 : controlStates[eventState]) === null || _b === void 0 ? void 0 : _b.avatarIconBackgroundColor;
  var avatarIconBorderColor = (_c = controlStates === null || controlStates === void 0 ? void 0 : controlStates[eventState]) === null || _c === void 0 ? void 0 : _c.avatarIconBorderColor;
  var shouldNotAllowHoverEffect = noHoverEffect && eventState === 'hover';
  var shouldNotAllowPressEffect = noPressEffect && eventState === 'pressed';
  if (shouldNotAllowHoverEffect || shouldNotAllowPressEffect) {
    backgroundColor = _backgroundColor || controlStates.none.backgroundColor;
    avatarBackgroundColor = controlStates.none.avatarIconBackgroundColor;
    avatarIconBorderColor = controlStates.none.avatarIconBorderColor;
  }
  var containerStyles = {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: spacingToken.SPACING_4,
    maxWidth: '100%'
  };
  var styles = {
    container: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      flexDirection: 'row',
      width: '100%',
      backgroundColor,
      alignItems: 'center',
      justifyContent: 'center'
    }, roundedCorners && {
      borderRadius: borderToken.BORDER_RADIUS_16
    }), !noPadding && !noHorizontalPadding && {
      paddingHorizontal: spacingToken.SPACING_16
    }), !noPadding && !noVerticalPadding && {
      paddingVertical: isLargeScreen ? spacingToken.SPACING_12 : spacingToken.SPACING_8
    }), showShadow && DISTANT), noPressEffect && checkIsPlatform('web') && {
      cursor: 'default'
    }),
    avatarContainer: {
      alignSelf: avatarPosition === 'center' ? 'center' : 'flex-start',
      marginRight: spacingToken.SPACING_8
    },
    avatarAsOffer: {
      borderRadius: borderToken.BORDER_RADIUS_100
    },
    avatar: Object.assign({}, avatarAsOffer ? {
      backgroundColor: TRANSPARENT
    } : Object.assign(Object.assign({}, !avatarNoBgContainer && avatarBackgroundColor && {
      backgroundColor: avatarBackgroundColor
    }), !avatarNoBgContainer && avatarIconBorderColor && {
      borderWidth: 1,
      borderColor: avatarIconBorderColor
    })),
    avatarOuterContainerStyles: {
      width: checkIsPlatform('web') ? 'auto' : null
    },
    typographySpacing: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'flex-start',
      flexDirection: 'column'
    },
    title: {
      marginBottom: title && !heading && !subHeading ? 0 : spacingToken.SPACING_4
    },
    headingContainer: Object.assign(Object.assign({
      flexDirection: 'row'
    }, heading && {
      marginBottom: spacingToken.SPACING_4
    }), {
      width: '100%',
      alignItems: 'center'
    }),
    icon: {
      marginLeft: spacingToken.SPACING_4,
      flexShrink: 0
    },
    infoTextContainer: {
      flexDirection: 'row',
      marginBottom: spacingToken.SPACING_8,
      marginTop: spacingToken.SPACING_4,
      width: '100%',
      overflow: 'hidden',
      alignItems: 'center'
    },
    metaInfoTag: {
      marginRight: spacingToken.SPACING_8
    },
    heading: {
      flexShrink: 1
    },
    headingInfoTag: {
      marginLeft: spacingToken.SPACING_4
    },
    headingLottie: {
      marginLeft: spacingToken.SPACING_4,
      width: headingLottieSize,
      height: headingLottieSize
    },
    subHeadingContainer: Object.assign({}, containerStyles),
    subTextContainer: Object.assign({}, containerStyles),
    subText3Container: Object.assign({}, containerStyles),
    subHeadingBoldText: {
      marginLeft: subHeading ? spacingToken.SPACING_4 : spacingToken.SPACING_0
    },
    subTextIcon: {
      marginRight: spacingToken.SPACING_4
    },
    subText: {
      marginRight: spacingToken.SPACING_4
    },
    rightContainer: Object.assign({
      display: 'flex',
      flexDirection: 'row',
      alignSelf: actionTypePosition === 'center' ? 'center' : 'flex-start',
      marginLeft: spacingToken.SPACING_8
    }, disableAppendActionType && {
      cursor: 'default'
    }),
    flexRow: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    rightSafeSpace: {
      marginRight: spacingToken.SPACING_8
    },
    tooltipHandling: {
      zIndex: -1
    },
    image: {
      height: isIllustration ? isLargeScreen ? 72 : 56 : isLargeScreen ? 56 : 40,
      width: isIllustration ? isLargeScreen ? 72 : 56 : isLargeScreen ? 56 : 40,
      marginRight: spacingToken.SPACING_8,
      alignSelf: imagePosition === 'center' ? 'center' : 'flex-start'
    },
    subtextPrefixicon: {
      marginRight: spacingToken.SPACING_4
    }
  };
  var items = {
    headingContainer: [heading, headingInfoTag],
    subHeadingContainer: [subHeading, subHeadingBold],
    subTextContainer: [subText, subTextBold],
    subText3Container: [subText3, subText3Bold],
    infoTextContainer: [metaInfoTag, metaInfoText],
    metaInfoCta: [metaInfoCta]
  };
  var order = ['headingContainer', 'subHeadingContainer', 'subTextContainer', 'subText3Container', 'infoTextContainer', 'metaInfoCta'];
  var lastItem = 'headingContainer';
  order.forEach(container => {
    items[container].forEach(elem => {
      if (elem) lastItem = container;
    });
  });
  if (styles[lastItem]) {
    styles[lastItem].marginBottom = spacingToken.SPACING_0;
  }
  return StyleSheet.create(styles);
};
export var getSubHeadingBoldTypeColor = (subHeadingBoldControlState, disabled, controlState) => {
  var colorMap = {
    none: BLACK_700,
    danger: RED_500,
    success: GREEN_600,
    disabled: BLACK_500,
    warning: YELLOW_500
  };
  if (disabled || controlState === 'disabled') return colorMap.disabled;
  return subHeadingBoldControlState && colorMap[subHeadingBoldControlState];
};
export var getActionTypeTextStateColor = function getActionTypeTextStateColor(actionTypeTextState) {
  if (actionTypeTextState === void 0) {
    actionTypeTextState = 'none';
  }
  var colorMap = {
    none: BLACK_900,
    success: GREEN_600,
    warning: YELLOW_600,
    danger: RED_500,
    white: BLACK_100
  };
  return colorMap[actionTypeTextState] || BLACK_900;
};
export var getLinkListItemProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(linkListItemConfig === null || linkListItemConfig === void 0 ? void 0 : linkListItemConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.linkListItem) === null || _a === void 0 ? void 0 : _a[theme]);
  var controlState = (props === null || props === void 0 ? void 0 : props.disabled) && 'disabled' || (props === null || props === void 0 ? void 0 : props.controlState) || (configProps === null || configProps === void 0 ? void 0 : configProps.controlState);
  return Object.assign(Object.assign(Object.assign({
    theme
  }, configProps), props), {
    controlState
  });
};